import styled from 'styled-components';
import Btn020 from 'dc/Btn020';

export const Container = styled.div`
  position: relative;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 646px;
  padding-top: 50px;
`;

export const Button = styled(Btn020)`
  margin: 32px 0 60px;
`;
